import type { IDataTime } from '@gp/pages/StudioMonthlyReport/types';

export const getDataTimes = (dataTimes: IDataTime[]): Record<string, string> => {
  if (!Array.isArray(dataTimes) || !dataTimes.length) return {};
  return dataTimes.reduce((acc, cur) => {
    const metric = cur?.metric || '';
    const dataTime = cur?.datatime || '';
    if (!metric) return acc;
    return { ...acc, [metric]: dataTime };
  }, {});
};
